import { getKeys } from './getKeys'

export const logsTranslations = {
  NEXT: 'Next',
  NEW_LOG: 'New log',
  ADD_CUSTOM_ENTRY: 'Add a custom entry',
  LOG_UNAVAILABLE: "This log's questions couldn't be loaded. Please try again.",
  CHOOSE_A_RESIDENT: 'Choose a {{nominative}}',
  CHOOSE_A_CATEGORY: 'Choose a Category',
  CHOOSE_AN_ITEM: 'Choose an Item',
  SEARCH_BY_NAME: 'Search by name',
  SAVE_LOG: 'Save Log',
  SAVE_AND_KEEP_LOGGING: 'Save and Keep Logging',
  ADD_LOCATION: 'Add location',
  LOCATION_SELECTED: 'Location: {{location}}',
  LOCATIONS_TITLE: 'Add location',
  LOCATIONS_EMPTY_TITLE: 'Locations will appear here!',
  LOCATIONS_EMPTY_SUBTITLE: 'Add some in the incident report settings',
  SEIZURE_CONFIRM_TITLE: 'Are you sure?',
  SEIZURE_ESCALATION_MSG:
    'If you escalate this log by accident you will have to start again.\n\nAny goals will have to be re-done after escalation.',
  SEIZURE_DE_ESCALATION_MSG:
    'If you de-escalate this log by accident you will have to start again.\n\nAny goals will have to be re-done after de-escalation.',
  SEIZURE_NOTE:
    'Note: If an incident seizure log is under 3 mins consider logging as a health recording',
  SEIZURE_LOG_AS_INCIDENT: 'Log as an Incident',
  SEIZURE_LOG_AS_HEALTH_RECORDING: 'Log as a Health Recording',
  PERSPECTIVE_ALERT_TITLE:
    "Amazing! You've captured the voice of your {{value}}",
  PERSPECTIVE_ALERT_MSG:
    'This log will be modified to first person, reflecting the perspective of the person under your care.',
  PERSPECTIVE_ALERT_DONT_SHOW: 'Don’t show this again',
  PERSPECTIVE_ALERT_LEARN_MORE: 'Learn more',
  PERSPECTIVE_ALERT_OK: 'OK',
  DATE_LOGGED: 'Date logged',
  TIME_LOGGED: 'Time logged',
  SKIPPED: 'Skipped',
  ADD_A_NEW: 'Add a new {{name}}',
  GROUP_ROW_TITLE: '{{type}} {{number}}',
  LABEL_WITH_COLON: '{{label}}:',
  REMOVE_ROW: 'Remove {{title}}',
  TIME: 'Time',
  FLAG_FOR_HANDOVER: 'Flag for handover',
  UNFLAG_FOR_HANDOVER_TITLE: 'Please confirm Un-Flag.',
  UNFLAG_FOR_HANDOVER_MSG:
    'If you un-flag this log it will not appear in the handover report.',
  UNFLAG: 'Un-Flag',
  CHANGE_LOG_PERSPECTIVE: 'Change log perspective',
  COMPLETED_BY_HIMSELF: 'This log has been completed by {{name}} himself',
  COMPLETED_BY_HERSELF: 'This log has been completed by {{name}} herself',
  COMPLETED_BY_THEMSELF: 'This log has been completed by {{name}} themself',
  ADD_MEDIA: 'Add Media',
  MEDIA_REMOVE_TITLE: 'Remove Media',
  MEDIA_REMOVE_PHOTO_MSG: 'Are you sure you want to remove this photo?',
  MEDIA_REMOVE_VIDEO_MSG: 'Are you sure you want to remove this video?',
  MEDIA_REMOVE_PHOTO_BTN: 'Remove Photo',
  MEDIA_REMOVE_VIDEO_BTN: 'Remove Video',
  MEDIA_LIMIT_TITLE: 'Upload limit reached',
  MEDIA_LIMIT_MSG: 'You reached the maximum number of media you can upload.',
  MEDIA_UPLOAD_ERROR: "We couldn't save your media. Please try again.",
  ADD_MORE_MEDIA: 'Add more media',
  LINK_A_GOAL: 'Link a goal',
  LINKING_GOALS_TITLE: 'Linking goals',
  NO_GOALS_TO_LINK: 'No goals to link',
  REMOVE_GOAL: 'Remove {{title}}',
  BACK: 'Back',
  MINUTES: 'Minutes',
  SECONDS: 'Seconds',
  DURATION_SECONDS_TOO_HIGH:
    'Please enter 59 seconds or fewer, and add any extra time to the minutes.',
  QUESTIONS_LOAD_ERROR: 'Error loading the questions for this log',
  LOG_ADDED_TOAST: 'Added a Log',
  LOG_ADD_FAILED_TOAST: 'Failed to add the log',
  MEDIA_UNSUPPORTED_FORMAT_TITLE: 'Photo format not supported',
  MEDIA_UNSUPPORTED_FORMAT_MSG:
    'This photo is in a format we can’t upload (e.g. RAW). Please choose a different photo.',
  VIDEO_UNSUPPORTED_FORMAT_TITLE: 'Video format not supported',
  VIDEO_UNSUPPORTED_FORMAT_MSG:
    'This video is in a format we can’t upload. Please choose an MP4, MOV or WebM video.',
  MEDIA_NOT_ALLOWED_TITLE: 'Media not allowed',
  MEDIA_NOT_ALLOWED_MSG:
    'Your home’s settings don’t allow this type of media on logs.',
  VIDEO_TOO_LONG_TITLE: 'Video limit exceeded',
  VIDEO_TOO_LONG_MSG:
    'This video is too large! Please select a clip of {{value}} seconds or under.',
  LOG_DUPLICATE_TOAST:
    "This log is a duplicate and can't be saved. Please try again after a short while."
}

export const logsConstants = getKeys(logsTranslations)
